




import Vue from 'vue';
export default Vue.extend({
    props: {
        error: {
            type: String,
            default: '',
        },
    },
});
